import { defaultFieldVisible, fieldKey } from './permissionUi';
import type { CatalogueEntry, FieldEntry } from './types';

/**
 * Field rows to save: only those that differ from the default (sensitive -> hidden, other -> visible).
 * The server treats an undescribed field by its current sensitivity, so a field that is marked
 * sensitive later is never exposed by an old explicit "visible" row that was merely a default.
 */
export function buildFieldEntries(catalogue: CatalogueEntry[], visible: Record<string, boolean>): FieldEntry[] {
  return catalogue.flatMap((entry) =>
    entry.fields.flatMap((f) => {
      const fallback = defaultFieldVisible(f.sensitive);
      const canView = visible[fieldKey(entry.resource, f.field)] ?? fallback;
      return canView === fallback ? [] : [{ resource: entry.resource, field: f.field, canView }];
    }),
  );
}
